import React, {useRef} from "react";

import {FIELD_TYPE, FORMAT_TIME, tabKeys} from "types/enums";
import {DilateStatusCard, ModalCustom} from "components/common";
import dayjs from "dayjs";

import {DataFormField} from "types/models/input-field-type";
import {
  gioiTinhOptions,
  trangThaiPKOptions,
} from "assets/constants/select-catagory-options";

const {INPUT, DATE, SELECT, AUTO_COMPLETE} = FIELD_TYPE;
import {examOutService} from "api";
import {
  birthday2Age,
  formatDateToString,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import PatientTypeColumn from "components/common/ColumnColors/KCBTypeColumn/PatientTypeColumn";
import {loaiBNOptions} from "assets/constants/kbnt-category";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
import moment from "moment";
import {ColumnsEdit} from "types/models/column-table-edit";

const updatePhieuKhamNT = async params => {
  try {
    let response = await examOutService.updateTrangThaiKBNT(params);
    return true;
  } catch (err) {
    return false;
  }
};

const fields = () => {
  const fields: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      name: "idBenhNhan",
    },
    {
      type: INPUT,
      label: "Họ tên",
      name: "hoTen",
    },
    {
      type: SELECT,
      label: "Giới tính",
      name: "gioiTinh",
      options: gioiTinhOptions,
    },
    {
      type: INPUT,
      label: "Số BHYT",
      name: "maTheBhyt",
    },
    {
      type: DATE,
      label: "Từ ngày",
      name: "ngayTaoTu",
    },
    {
      type: DATE,
      label: "Đến ngày",
      name: "ngayTaoDen",
    },
    {
      type: SELECT,
      label: "Trạng thái",
      name: "trangThaiPK",

      options: trangThaiPKOptions,
      rules: [{required: true, message: "Trạng thái phiếu khám là bắt buộc"}],
    },
  ];
  return fields;
};

const fieldsSearch: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã phiếu khám",
    name: "maPK",
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "maBenhNhan",
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
  },
  {
    type: INPUT,
    label: "Ngày sinh",
    name: "ngaySinh",
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    options: gioiTinhOptions,
  },
  {
    type: AUTO_COMPLETE,
    label: "Họ tên BSy",
    name: "bacSyKham",
  },
  {
    type: SELECT,
    label: "Loại KCB",
    name: "loaiKCB",
    options: JSON.parse(localStorage.getItem("loaiKCB")) || [],
  },
  {
    type: DATE,
    label: "Ngày tạo từ",
    disableDate: false,
    name: "ngayTaoTu",
  },
  {
    type: DATE,
    label: "Ngày tạo đến",
    name: "ngayTaoDen",
    disableDate: false,
  },
  {
    type: SELECT,
    label: "Trạng thái khám",
    name: "trangThaiKBNT",
    options: JSON.parse(localStorage.getItem("TTPhieu")) || [],
  },
  {
    type: SELECT,
    label: "Phòng khám",
    name: "phong",
    options: JSON.parse(localStorage.getItem("phongKhamNoPeople")) || [],
  },
  {
    type: SELECT,
    label: "Khu KCB",
    name: "khuKham",
    options: JSON.parse(localStorage.getItem("khuKham")) || [],
  },
];

const listExamColumns: ColumnsEdit = [
  {
    key: "stt",
    title: "STT",
    dataIndex: "stt",
    show: true,
    isResizable: true,
    render: (v, r, idx) => idx + 1,
    align: "center",
    width: 40,
    // isResizable: true
  },
  {
    key: "maBenhNhan",
    title: "Mã BN",
    dataIndex: "maBenhNhan",
    show: true,
    isResizable: true,
    width: 60,
    align: "center",
    // isResizable: true
  },
  {
    key: "idPhieuKham",
    title: "Mã PK",
    dataIndex: "idPhieuKham",
    show: true,
    isResizable: true,
    width: 60,
    align: "center",
    // isResizable: true
  },
  {
    title: "Tên BN",
    key: "hoTen",
    dataIndex: "hoTen",
    align: "left",
    width: 140,
    show: true,
    isResizable: true,
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    dataIndex: "gioiTinh",
    align: "left",
    width: 60,
    show: true,
    isResizable: true,
    render: v => gioiTinhOptions.find(it => it.value === v)?.label || "",
    // isResizable: true
  },
  {
    title: "Ngày sinh",
    key: "ngaySinh",
    dataIndex: "ngaySinh",
    show: true,
    isResizable: true,
    align: "center",
    width: 80,
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",
    // isResizable: true
  },
  {
    title: "Tuổi",
    key: "tuoi",
    dataIndex: "tuoi",
    render: (text, record: {ngaySinh: Date}) =>
      record.ngaySinh ? birthday2Age(record?.ngaySinh) : "",
    width: 60,
    show: true,
    isResizable: true,
    align: "center",
    // isResizable: true
  },
  {
    title: "Số điện thoại",
    dataIndex: "dienThoai",
    show: true,
    isResizable: true,
    align: "right",
    width: 100,
    // isResizable: true
  },
  {
    title: "Thời gian tiếp nhận",
    key: "ngayNhapVien",
    dataIndex: "ngayNhapVien",
    render: (text, record) =>
      text ? moment(text).format(FORMAT_TIME.dateTime) : "",
    show: true,
    width: 150,
    align: "center",
    isResizable: true,
  },
  {
    title: "Ngày tạo",
    dataIndex: "ngayTao",
    key: "ngayTao",
    show: true,
    isResizable: true,
    align: "center",
    width: 120,
    render(value, record, index) {
      return <>{formatDateToString(value, FORMAT_TIME.dateTime)}</>;
    },
    // isResizable: true
  },
  {
    title: "Tra thuốc",
    key: "traThuoc",
    dataIndex: "traThuoc",
    show: true,
    isResizable: true,
    width: 80,
    render(value, record, index) {
      return (
        <DilateStatusCard
          active={false}
          name={record?.tenThuoc}
          status={record.trangThaiTraThuoc}
          timeDilate={record.thoiGianTraThuoc}
        ></DilateStatusCard>
      );
    },
    // isResizable: true
  },
  {
    title: "Địa chỉ",
    key: "diaChiTongHop",
    dataIndex: "diaChiTongHop",
    show: false,
    isResizable: true,
    width: 180,
    // isResizable: true
  },
  {
    title: "Phòng",
    key: "tenPhong",
    dataIndex: "tenPhong",
    show: true,
    isResizable: true,
    width: 120,
    // isResizable: true
  },
  {
    title: "Loại KCB",
    key: "loaiKCB",
    dataIndex: "loaiKCB",
    show: true,
    isResizable: true,
    width: 120,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("loaiKCB")).find(
          option => option.value === text
        )?.label || "";
      return <KCBTypeColumn label={ten} />;
    },
    // isResizable: true
  },
  {
    title: "Loại bệnh nhân",
    dataIndex: "loaiBenhNhans",
    show: true,
    isResizable: true,
    align: "center",
    render: text => {
      const loaiBN =
        loaiBNOptions.find(option => option.value === text?.[0])?.label || "";
      return <PatientTypeColumn label={loaiBN} />;
    },
    // isResizable: true
  },
  {
    title: "Trạng thái KBNT",
    key: "trangThai",
    dataIndex: "trangThai",
    show: true,
    isResizable: true,
    width: 120,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("TTPhieu")).find(
          option => option.value === text
        )?.label || "";
      return <KCBStatusColumn label={ten} />;
    },
  },
  {
    title: "Họ tên BS",
    key: "bacSyKham",
    dataIndex: "bacSyKham",
    show: true,
    isResizable: true,
    width: 160,
    // isResizable: true
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    align: "center",
    fixed: "right",
    show: true,
    isResizable: true,
    width: 80,
  },
];

const fastFilter = [
  {
    value: "today",
    label: "Hôm nay",
  },
  {
    value: "yesterday",
    label: "Hôm qua",
  },
];
export {listExamColumns, fields, fastFilter, updatePhieuKhamNT, fieldsSearch};
